'use client';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-rc-bg">
      <Navbar />
      <main className="pt-14 flex items-center justify-center min-h-[80vh]">
        <div className="text-center">
          <h1 className="text-rc-orange text-8xl font-black mb-4">404</h1>
          <h2 className="text-white text-2xl font-bold mb-3">Page Not Found</h2>
          <p className="text-gray-400 mb-8">The page you&apos;re looking for doesn&apos;t exist.</p>
          <a
            href="/"
            className="px-8 py-3 bg-rc-orange hover:bg-primary-dark text-white font-bold rounded-xl transition-colors"
          >
            Go Home
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}